import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import config from '@/uitls/version.json';
import editeIcon from "@/assets/images/bianji_icon.png";
import Platform from "@/config/platform";
import { serverConfigPiniaState } from "@/store/serverConfig";
import { formatDate, YMPush } from "@/uitls/uitls";
import { Storage } from "@/uitls/Storage";
import { getVipData } from "@/api/php/user";
import IMUtils from "@/network/socket/imUtils";
import noLoginAvatar from "@/assets/images/noLogin.png";
import { useI18n } from "vue-i18n";
import { toLocationBrowser, toMsgChat, nativeToLogin } from "@/uitls/native";
import { testSign } from "@/api/php/serverConfig";


export default /*#__PURE__*/_defineComponent({
  name: 'Me',
  setup(__props, { expose }) {
  expose();

const channelId = process.env.VUE_APP_CHANNEL as string;

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const piniaStore = usePiniaState();
const { user, isYk, isQD } = storeToRefs(piniaStore);
const { toLogin } = piniaStore;
const vip1 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_0.png`)
const vip2 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_1.png`)
const vip3 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_2.png`)
const vip4 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_3.png`)
const vip5 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_4.png`)
const vip6 = require(`@/assets/${process.env.VUE_APP_NAME}/vip_room_min_5.png`)
const ConfigpiniaStore = serverConfigPiniaState();
const { offStore, matchAD, service_uid, is_has_history, is_show_host, is_lb, h5Foot } = storeToRefs(ConfigpiniaStore);
let level = ref(0);
const VipLevelImg = [vip1, vip2, vip3, vip4, vip5, vip6];
const version = process.env.VUE_APP_VERSION as string;
const th = process.env.VUE_APP_Language as string;
let size: any = ref(0)


onMounted(async () => {
  await toLogin();
  YMPush("MAIN", "MinePage");
  if (!isYk.value) {
    getvip();
  }

  console.log("user", user.value);
  console.log('isYK.value', isYk.value)

  var storage = window.localStorage;
  size.value = 0;
  for (var i = 0; i < storage.length; i++) {
    var key = storage.key(i); // 获取第 i 个条目的键名
    var value = storage.getItem(key); // 获取第 i 个条目的值
    size.value += key.length + value.length; // 累加键名和值的长度
  }
  size.value = (size.value / 1024 + 1).toFixed(2); // 转换为 KB，并保留两位小数
  // console.log("window.localStorage 的大小为 " + size.value + " KB");

  // requestTestSign();
});

// const requestTestSign = async() =>{
//   debugger;
//   const res:any = await testSign();
  
//   console.log("res= ", res);
//   debugger;
// };


const huanc = () => {
  let TOKEN = Storage.get('TOKEN');
  let UID = Storage.get('UID');
  let PHONE = Storage.get('PHONE');
  let CUSTOMERID = Storage.get('CUSTOMERID');
  let FASTKEY = Storage.get('FASTKEY');
  let IDENTIFIER = Storage.get('IDENTIFIER');
  let DEVICE_ID = Storage.get('DEVICE_ID');
  Storage.clear();
  Storage.clearCookie();
  Storage.set('TOKEN', TOKEN);
  Storage.set('UID', UID);
  Storage.set('PHONE', PHONE);
  Storage.set('CUSTOMERID', CUSTOMERID);
  Storage.set('FASTKEY', FASTKEY);
  Storage.set('DEVICE_ID', DEVICE_ID);
  // Storage.set('IDENTIFIER',IDENTIFIER);
  console.log('清除缓存');
  window.location.reload();
}
const onCickLogin = () => {
  
  
  //判断要不要登录
  if (isYk.value) {
    nativeToLogin(router);
  } else {
    router.push(`/viplevel`);
  }
};
const vipName = ref("");
const getvip = async () => {
  // 获取用户等级
  const res: any = await getVipData();
  if (res.code == 200) {
    level.value = res.data.level;
    switch (level.value) {
      case 0:
        vipName.value = t("me.lvxl");
        break;
      case 1:
        vipName.value = t("me.lvht");
        break;
      case 2:
        vipName.value = t("me.lvby");
        break;
      case 3:
        vipName.value = t("me.lvhj");
        break;
      case 4:
        vipName.value = t("me.lvbj");
        break;
      case 5:
        vipName.value = t("me.lvzs");
        break;
      default:
        vipName.value = "新秀";
        break;
    }
  }
};

const serban = (value) => {
  
  switch (value) {
    case "积分商城":
      if (isYk.value) {
        return nativeToLogin(router);
      }
      const time = new Date().getTime();
      //今天的日期
      const day = formatDate(time);
      Storage.set("jfStoreDay", day);
      // router.push(`/integralwallet/0/${user.value.customerId}/${user.value.token}/0`);
      router.push(`/integralwallet`);
      break;
    case "关注主播":
      if (isYk.value) {
        return nativeToLogin(router);
      }
      router.push("/Subscribe");
      break;
    case "观看历史":
      router.push("/History");
      break;
    case "联系客服":
      let chatkey;
      
      chatkey = IMUtils.createChatKey(Platform.serverId);
      router.push(`/chat/?id=${chatkey}`);
      break;
    case "关于我们":
       router.push("/Aboat");
      //  router.push('pointGuessingActive');
      break;
    case "设置":
      router.push("/Syssetting");
  }
};

const toProposal = () => {
  let chatkey = IMUtils.createChatKey(Platform.serverId);
  router.push(`/chat/?id=${chatkey}`);
};

const toServer = () => {
  
  const id = parseInt(service_uid.value);
  let chatkey;
  chatkey = IMUtils.createChatKey(id).toString();
  toMsgChat(router, id, chatkey);

}

const __returned__ = { channelId, t, router, route, piniaStore, user, isYk, isQD, toLogin, vip1, vip2, vip3, vip4, vip5, vip6, ConfigpiniaStore, offStore, matchAD, service_uid, is_has_history, is_show_host, is_lb, h5Foot, level, VipLevelImg, version, th, size, huanc, onCickLogin, vipName, getvip, serban, toProposal, toServer, editeIcon, noLoginAvatar, toLocationBrowser }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})